import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  GetActionRequestsActivityResponseDataSchema,
  GetActivitySchema,
  GetIssueDeflectionActivityResponseDataSchema,
  GetQuestionsActivityResponseDataSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetActivitySchema>

type Props = {
  enabled?: boolean
  query?: Query
}

const buildActivityQuery = <T>(metric: string, path: string) => {
  return ({ enabled = false, query }: Props = {}) =>
    queryOptions({
      queryKey: [metric, JSON.stringify(query)],
      queryFn: async () => {
        const response = await axios.get<DataResponse<T>>(`/insights/activity/${path}`, {
          params: query,
        })
        return response.data.data
      },
      enabled,
    })
}

export const issueDeflectionActivityQuery = buildActivityQuery<
  z.infer<typeof GetIssueDeflectionActivityResponseDataSchema>
>("issueDeflectionActivity", "issue-deflection")

export const questionsActivityQuery = buildActivityQuery<
  z.infer<typeof GetQuestionsActivityResponseDataSchema>
>("questionsActivity", "questions")

export const actionRequestsActivityQuery = buildActivityQuery<
  z.infer<typeof GetActionRequestsActivityResponseDataSchema>
>("actionRequestsActivity", "action-requests")
